<div id="detailed-page-container">
    <div id="detailed-page-left-container">
        <app-video-detailed></app-video-detailed>
        <app-comment-list></app-comment-list> 
    </div>
    <div id="detailed-page-right-container">
        <app-video-list
        [width] = "ww"
        [styleObj] = styleObjj
        ></app-video-list>
    </div>
</div>